var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-center items-center"},[_c('div',{class:_vm.classes,attrs:{"id":_vm.chatConfig.buttonContainerId}})])}
var staticRenderFns = []

export { render, staticRenderFns }